import * as z from 'zod'

import { api } from '../../utils/api'

const InputSchema = z.tuple([])

const OutputSchema = z.promise(z.any())

const FunctionSchema = z.function(InputSchema, OutputSchema)

export const DoLogout = FunctionSchema.implement(async () => await api.post(`/user/logout`))